import { ReactFlowInstance, Node, Edge } from "@xyflow/react";
import { RJSFSchema } from "@rjsf/utils";

/**
 * Delete workflow node and all child nodes and edges
 * @param context
 * @param reactFlowInstance
 */
export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeEditHQCreateNode.id)) {
            newNodes.push(node);
        }
    }

    let edges: Edge[] = context.edges;
    let newEdges: Edge[] = [];
    for (const edge of edges) {
        if (!edge.id.includes(context.activeEditHQCreateNode.id)) {
            newEdges.push(edge);
        }
    }

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode: Node = context.activeEditHQCreateNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes: Node[] = reactFlowInstance.getNodes();
    let newNodes: Node[] = [];
    let activeIds: any[] = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes: Node[] = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }
    ;
    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}

export const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    required: [],
    properties: {
        'data_input': {
            title: 'Data Input',
            type: 'string',
            description: 'Location of data to create entity',
            default: 'default'
        },
        entity_or_action: {
            title: 'Entity or Action',
            type: 'string',
            enum: [
                'Entity',
                'NokNok Action'
            ],
            default: 'Entity'
        },

        'data_management': {
            title: 'Data Store',
            type: 'string',
            description: 'Location to store update response',
            default: 'default'
        },
        add_output_to_message: {
            title: 'Add Output To Messages',
            type: 'boolean',
            default: false,
            description: 'Store output as a message to keep in the message history as well as Data store',
        }
    },
    allOf: [
        {
            if: {
                properties: {
                    entity_or_action: {
                        const: 'Entity'
                    }
                }
            },
            then: {
                properties: {
                    entity_data: {
                        title: '',
                        type: 'object',
                        properties: {
                            entity_type: {
                                title: 'Entity Type',
                                type: 'string',
                                enum: [
                                    'Customer (not available yet)',
                                    'Company',
                                    'Website',
                                    'Url',
                                    'Contacts',
                                    'Emails',
                                    'Telephone Numbers',
                                    'Address',
                                    'Social Media',
                                    'Employees',
                                    'Email Metric',
                                    'Mystery Shopper Email Validation',
                                ],
                                default: 'Customer (not available yet)'
                            },
                        },
                        allOf: [
                            {
                                if: {
                                    properties: {
                                        entity_type: {
                                            const: 'Mystery Shopper Email Validation'
                                        }
                                    }
                                },
                                then: {
                                    properties: {
                                        // Records a pass for the Mystery Shopper validation
                                        // workflow. Data Input is the validator's answer, and
                                        // nothing is posted unless its verdict is "pass". The ids
                                        // come from data_five, which the bridge fills.
                                        mystery_shopper_email_validation__options: {
                                            title: 'Mystery Shopper Email Validation Option',
                                            type: 'string',
                                            enum: [
                                                'Record Pass',
                                            ],
                                            default: 'Record Pass'
                                        },
                                        email_input: {
                                            title: 'Email Input',
                                            type: 'string',
                                            description: 'Slot holding the email that passed: data_two for the customer\'s draft, or the first validator\'s slot to record its suggestion',
                                            default: 'data_two'
                                        },
                                    }
                                }
                            },
                        ],
                    }
                }
            }
        },

        {
            if: {
                properties: {
                    entity_or_action: {
                        const: 'NokNok Action'
                    }
                }
            },
            then: {
                properties: {
                    custom_action: {
                        title: 'NokNok Action',
                        type: 'string',
                        enum: [
                            'Create EmailFinder Results',
                            'Do A Third Thing',
                            'Do Something New',
                            'Do All The Things',
                        ],
                        default: 'Create EmailFinder Results'
                    }
                },
            }
        },
        {
            if: {
                properties: {
                    data_management: {
                        const: 'messages'
                    }
                }
            },
            then: {
                properties: {
                    add_output_to_message: {
                        readOnly: true,
                    }
                }
            }
        }
    ]
}

export const nodeDescription: string = "This node is used to create a new entity in HQ.\n";